import React, {useEffect} from 'react';
import {Link} from 'react-router-dom'
import $ from 'jquery'

export default function ModalViewComponent (props) {
    useEffect(() => {
        $('#payment-confirm').modal('show'); 
    })

    return (
        <section>
            <div class="modal fade"  data-backdrop= "static" data-keyboard="false" id = "payment-confirm" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 className = {`modal-title font-weight-bold sofia-pro ${props.success_flag} ? text-muted : text-danger`}>{props.title}</h5>
                        </div>
                        <div class="modal-body">
                            <p className = "urw-din">{props.message}</p>
                            <p className = "urw-din">{props.extra}</p>
                        </div>
                        <div class="modal-footer">
                            {!props.success_flag &&
                                <button type="button" class="btn btn-dark" onClick = {() => {
                                        if (props.failure_redirect_url) window.open(props.failure_redirect_url, '_self')
                                        else window.location.reload(false)}} data-dismiss="modal">Close</button>}
                            {props.success_flag && 
                                <a href = {props.redirect_url} className="btn btn-lg btn-success sofia-pro">{props.button_text}</a>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}